// Auto-generated helper: Prompt to convert unstructured notes to a valid Diagram JSON (v2)
const generateDiagramPrompt = `Title: Convert unstructured service notes to Service Diagram JSON (version 2)

System/Role
You are a disciplined data transformation assistant. Given unstructured system design or brainstorming notes, produce a valid JSON document that matches the Service Diagram Editor schema precisely. Output JSON only.

What to produce
- One JSON object that conforms to the Service Diagram Editor schema (version 2):
  - Diagram
    - id: string (omit or set to null; the app will generate)
    - name: string
    - description?: string
    - version: 2
    - nodes: ServiceNode[]
      - id: string (stable, kebab-case slug of name; must be unique)
      - name: string
      - type: "main" | "internal" | "external" | "convoy"
      - position: { x: number; y: number } (simple grid is fine)
      - description?: string
      - endpoints?: ServiceEndpoint[]
        - id: string (kebab-case slug + counter)
        - path: string (URL or path; keep env vars as-is)
        - method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH"
        - description?: string
        - isPaused?: boolean
      - convoyRoutes?: ConvoyRoute[] (only for type "convoy")
        - id: string (kebab-case slug)
        - name: string
        - targetServiceId?: string (node id if known)
        - targetServiceName?: string
        - description?: string
        - isPaused?: boolean
      - linkedDiagramId?: string (omit if unknown)
    - connections: ServiceConnection[]
      - id: string (conn-<source>-to-<target>-<n>)
      - source: string (node id)
      - target: string (node id)
      - sourceHandle?: string ("source-left" | "source-right" | "source-top" | "source-bottom" | \`route-<routeId>\`)
      - targetHandle?: string ("target-left" | "target-right" | "target-top" | "target-bottom")
      - type?: "direct" | "convoy" | "convoy-route" | "webhook" (default "direct")
      - animated?: boolean (true for convoy-route)
      - label?: string
      - convoyRouteId?: string (when using a convoy route)
      - curveOffset?: number (default 0)
    - createdAt?: string (ISO) – optional
    - updatedAt?: string (ISO) – optional

Transformation rules
1. Node classification heuristics
   - If name contains "convoy", classify as type "convoy".
   - Names like Main, App, API Gateway → type "main".
   - First-party/internal services → type "internal".
   - Third-party/providers (CMA CGM, MSC, Vizion, etc.) → type "external".
   - If notes mention "legacy" (e.g., 4D), use type "internal".

2. Parse endpoints
   - Extract lines that look like HTTP method + URL/path.
   - Preserve env vars/placeholders literally (e.g., ${process.env.MSC_BASE_URL}).
   - Attach endpoints to the service they belong to based on surrounding headings/sections.

3. Convoy routes
   - For any lines like "BroadcastType.CONVOY -> BroadcastProjectTypes.X", create a convoy node with routes.
   - Each route becomes a ConvoyRoute with a stable id (kebab-case of name) and target service name if identifiable.
   - For connections that use a convoy route, set:
     - source = convoy node id
     - sourceHandle = \`route-<routeId>\`
     - target = target service id
     - type = "convoy-route"
     - animated = true

4. Connections from free-text
   - Use phrases like "send to X" or endpoint groups under a service section to infer edges.
   - Direction: the service owning the described call → target service.
   - If the call is to a convoy route, connect service → convoy, and convoy route → target service.

5. Handles and layout
   - Assign initial handles by relative layout:
     - If target.x > source.x → sourceHandle="source-right", targetHandle="target-left".
     - If target.x < source.x → sourceHandle="source-left", targetHandle="target-right".
     - If aligned vertically, use top/bottom accordingly.
   - Provide simple grid positions so the diagram isn’t stacked. Example layout:
     - main at { x: 100, y: 200 }
     - convoy near center at { x: 400, y: 200 }
     - internal/external targets to the right in rows, spacing 140px vertically.
   - Set curveOffset to 0 unless disambiguation is needed.

6. IDs
   - Node ids: kebab-case of name, unique (add numeric suffix if needed).
   - Endpoint ids: <node-id>-ep-<n>.
   - Route ids: kebab-case route name.
   - Connection ids: conn-<source>-to-<target>-<n>.

7. Output constraints
   - Output strictly valid JSON; no comments or trailing commas.
   - Do not include Markdown fences.
   - Do not generate code; only data.

Input placeholder
{NOTES}

End of prompt.`;

export default generateDiagramPrompt;

